module.exports = __webpack_public_path__ + "1ed96ff67fea357f15e5e581f7ff0997.png";